// extracted by mini-css-extract-plugin
module.exports = {"root":"_b19fef","pagination":"_144a5b"};